import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import NoSsr from '@material-ui/core/NoSsr';
import { isApp } from 'services/environment';

const MeteredAccessBanner = React.lazy(() =>
  import(/* webpackChunkName: 'metered-access-banner' */ 'components/MeteredAccess/MeteredAccessBanner'),
);

function MeteredAccess() {
  const accessPolicy = useSelector(state => state.meteredAccess.accessPolicy);
  const promoEnabled = useSelector(state => state.config.paywall.meteredAccess.promoEnabled);
  const userLocation = useSelector(state => state.user.geolocation.countryCode);
  const cookieConsent = useSelector(state => state.user.cookie_consent);
  const isCorporate = useSelector(state => state.user.geolocation.corporate);

  const isAppAndConsent = (cookieConsent !== 'pending' && cookieConsent !== 'displayed') || isApp();

  if (!accessPolicy || !isAppAndConsent || isCorporate) {
    return null;
  }

  return (
    <NoSsr defer>
      <Suspense fallback={null}>
        <MeteredAccessBanner
          id={accessPolicy.id}
          canView={accessPolicy.canView}
          hasQuota={accessPolicy.hasQuota}
          quota={accessPolicy.quota}
          quotaPeriod={accessPolicy.quotaPeriod}
          used={accessPolicy.used}
          permittedItems={accessPolicy.permittedItems}
          isFirstClickFreeAccess={accessPolicy.isFirstClickFreeAccess}
          withPromo={promoEnabled && (!userLocation || userLocation === 'GB')}
          accessPolicy={accessPolicy}
        />
      </Suspense>
    </NoSsr>
  );
}

export default React.memo(MeteredAccess);
